
import { Button, Col, List, Modal, Row, message } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import servicePath from '../config/apiUrl';
import '../static/css/CameraList.css';
const { confirm } = Modal;
function CameraList(props) {

    const [list, setList] = useState([])
    // const [surfSpotGeoList, setSurfSpotGeoList] = useState([])
    //获取摄像头列表
    const getList = () => {
        const key = 'getList';

        message.loading({ content: '加载数据...', key });
        axios({
            method: 'get',
            url: servicePath.cameraList,
            withCredentials: true,
            header: { 'Access-Control-Allow-Origin': '*' }
        }).then(
            res => {
                if (res.data.code == 1) {
                    setList(res.data.list)
                    message.success({ content: '加载数据成功！', key, duration: 2 });
                } else {
                    message.error({ content: '加载数据失败！', key, duration: 2 });
                }
            }
        ).catch((res) => {
            console.log("err", res)
            message.error({ content: '加载数据失败！', key, duration: 2 });
        })
    }
    
    // 获取浪点地理列表
    // const getSurfSpotGeoList = () => {
    //     axios({
    //         method: 'get',
    //         url: servicePath.getSurfSpotGeoList,
    //         withCredentials: true,
    //         header: { 'Access-Control-Allow-Origin': '*' }
    //     }).then(
    //         res => {
    //             if (res.data.code == 1) {
    //                 setSurfSpotGeoList(res.data.list)
    //             }
    //         }
    //     ).catch((res) => {
    //         console.log("err", res)
    //     })
    // }
    
    // 根据ID获取浪点地理信息
    // const getSurfSpotGeoInfo = (ssg_id) => {
    //     if (!ssg_id) return '未设置';
    //     const surfSpotGeo = surfSpotGeoList.find(item => item.id == ssg_id);
    //     if (surfSpotGeo) {
    //         return `ssg_id:${surfSpotGeo.id} ${surfSpotGeo.district} ${surfSpotGeo.province} ${surfSpotGeo.country}`;
    //     }
    //     return '未找到';
    // }

    useEffect(() => {
        getList()
        // getSurfSpotGeoList()
    }, [])


    //删除摄像头的方法
    const delArticle = (id) => {
        confirm({
            title: '确定要删除这个摄像头信息吗?',
            content: '如果你点击OK按钮，将会永远被删除，无法恢复。',
            onOk() {
                axios(servicePath.delArticle + '/' + id, { withCredentials: true }).then(
                    res => {
                        message.success('摄像头删除成功')
                        getList()
                    }
                )
            },
            onCancel() {
                message.success('没有任何改变')
            },
        });

    }
    //修改摄像头
    const updateArticle = (id, checked) => {

        props.history.push('/index/EditCamera/' + id)

    }
    return (
        <>
            <div>

                <List
                    header={
                        <Row className="list-div">
                            <Col span={2}>
                                <b>摄像头ID</b>
                            </Col>
                            <Col span={2}>
                                <b>名字</b>
                            </Col>
                            <Col span={1}>
                                <b>排序</b>
                            </Col>
                            <Col span={2}>
                                <b>城市</b>
                            </Col>
                            <Col span={2}>
                                <b>赞助商</b>
                            </Col>

                            <Col span={3}>
                                <b>海报图片</b>
                            </Col>
                            <Col span={2}>
                                <b>latitude</b>
                            </Col>
                            <Col span={2}>
                                <b>longitude</b>
                            </Col>
                            {/* <Col span={3}>
                                <b>浪点所属地理信息</b>
                            </Col> */}
                            <Col span={2}>
                                <b>是否展示</b>
                            </Col>
                            <Col span={2}>
                                <b>展示播放图片</b>
                            </Col>
                            <Col span={2}>
                                <b>展示录制图标</b>
                            </Col>
                            <Col span={2}>
                                <b>操作</b>
                            </Col>
                        </Row>

                    }
                    bordered
                    dataSource={list}
                    renderItem={item => (
                        <List.Item>
                            <Row className="list-div">
                                <Col span={2}>
                                    {item.cId}
                                </Col>
                                <Col span={2}>
                                    {item.name}
                                </Col>
                                <Col span={1}>
                                    {item.sort}
                                </Col>
                                <Col span={2}>
                                    {item.city}
                                </Col>
                                <Col span={2}>
                                    {item.sponsor}
                                </Col>

                                <Col span={3}>
                                    {/* {item.post_url} */}
                                    <img style={{ width: '60px', height: 'auto' }} src={servicePath.serverUrl + item.post_url} />
                                </Col>
                                <Col span={2}>
                                    {item.latitude}
                                </Col>
                                <Col span={2}>
                                    {item.longitude}
                                </Col>
                                {/* <Col span={3}>
                                    {getSurfSpotGeoInfo(item.ssg_id)}
                                </Col> */}
                                <Col span={2}>
                                    {item.hide == 1 ? '不展示' : "展示"}
                                </Col>
                                <Col span={2}>
                                    {item.show_play_icon == 1 ? '展示' : "不展示"}
                                </Col>
                                <Col span={2}>
                                    {item.show_rec_icon == 1 ? '展示' : "不展示"}
                                </Col>


                                <Col span={2}>
                                    <Button type="primary" onClick={() => { updateArticle(item.cId) }}>修改</Button>&nbsp;
                                    {/* <Button onClick={()=>{delArticle(item.cId)}}>删除 </Button> */}
                                </Col>
                            </Row>

                        </List.Item>
                    )}
                />

            </div>
        </>
    )

}

export default CameraList